/**
 * boardHasLoadingCards — true while any document card on the canvas is still
 * showing its thumbnail-loading skeleton.
 *
 * Document cards (DocumentIcon) render an `animate-pulse` placeholder until
 * their async preview (PDF page raster / P&ID image) arrives. Capturing the
 * board preview during that window freezes blank-white cards into the
 * thumbnail — and because the preview's content hash covers only the shape
 * graph and geometry (pixels aren't in it), the blank capture then gates
 * every retry off: the board keeps "rendering nothing" on the boards list
 * until the user happens to move or resize a card. Callers should defer the
 * capture and retry while this returns true.
 */
export function boardHasLoadingCards(canvasRoot: HTMLElement): boolean {
  return canvasRoot.querySelector('.tl-html-container .animate-pulse') !== null
}
